<app-base-template (modal)="openModal(content)" (dataExportToExcel)="exportToExcel()" (tabledata)="getTableData()"
  [displayData]="displayData" [nextOffset]="nextOffset" [previousOffset]="previousOffset" (offset)="getData($event)"
  (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage" [isExportDisable]="isExportDisable"
  [showExportBtn]="showExportBtn" [showSearch]="showSearch" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Maintain Email Attributes</div>

  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
    
    <mat-radio-group aria-label="Select an option" [(ngModel)]="selectedTypeValue" (change)="onChnageSenderType()">
      <mat-radio-button class="emailticketradiobtn" [value]="1">Configure Attributes &nbsp;&nbsp;&nbsp;
      </mat-radio-button>
      <mat-radio-button class="emailticketradiobtn" [value]="2" *ngIf="clientId == 2 || clientId === '2'">Map IC wise
        Category</mat-radio-button>

    </mat-radio-group>

    <div class="form-group" style="margin-top: 9px;" *ngIf="selectedTypeValue == 1">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="AttributrTitle"
        placeholder="Enter Attribute Type">
    </div>

    <div class="form-group" *ngIf="selectedTypeValue == 1">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="AttributrValue"
        placeholder="Enter Attribute Value">
    </div>


    <div class="form-group" *ngIf="selectedTypeValue == 2">
      <input type="text" class="form-control radius-0 font-13" [(ngModel)]="AttributrName"
        placeholder="Enter IC / UNIT Mapping">
    </div>



    <div class="form-group" *ngIf="selectedTypeValue == 2">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketSelected"
        (change)="onTicketChange($event.target.selectedIndex)">
        <option *ngFor="let ticket of tickets" [value]="ticket.id">{{ticket.name}}</option>
      </select>
    </div>

    <div class="row" *ngIf="selectedTypeValue == 2">
      <div class="col-md-12 pad-15 category">
        <select class="custom-select  tcktyp" *ngFor="let ticket of ticketTypes;" [disabled]="ticket.isDisabled"
          (change)="onCategoryChangeDropDown(ticket,$event.target.value)" id="ticket_{{ticket.id}}">
          <option *ngFor="let option of ticket.options" [value]="option|json">{{option.title}}</option>
        </select>
      </div>
    </div>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>


<notifier-container></notifier-container>